<template lang="pug">
  div(:class="b({ selected })" @click="onClick")
    figure(:class="b('icon')")
      img(:src="productIcon")
    div(:class="b('body')")
      div(:class="b('name')" v-html="item.title")
    div(:class="b('check')")
      rtc-icoimage(v-show="selected" name="check-circle-blue")
</template>

<script>
import {
  NEW_MORTGAGE_SLUG,
  BUY_MORTGAGE_SLUG,
  ADVISER_SLUG,
  HOME_EQUITY_LOAN_SLUG,
  HOUSE_REMODELING_PRODUCT_MOTIVE,
  DEBT_CONSOLIDATION_PRODUCT_MOTIVE,
  WORK_CAPITAL_PRODUCT_MOTIVE,
} from '@/utils/constants';
import productSelectionParser from '@/utils/product-selection-parser';

export default {
  name: 'product-choice-item',

  props: {
    item: { type: Object, required: true },
    selected: { type: Boolean, default: false },
  },

  methods: {
    onClick() {
      this.$emit('click', this.item);
    },
  },

  computed: {
    productIcon() {
      const { product, motive } = productSelectionParser.parse(this.item.value);

      const fileName = do {
        if (product === NEW_MORTGAGE_SLUG) 'couple'
        else if (product === BUY_MORTGAGE_SLUG) 'piggy'
        else if (product === ADVISER_SLUG) 'man-worried'
        else if (product === HOME_EQUITY_LOAN_SLUG) {
          if (motive === HOUSE_REMODELING_PRODUCT_MOTIVE) 'house-cash'
          else if (motive === DEBT_CONSOLIDATION_PRODUCT_MOTIVE) 'sign'
          else if (motive === WORK_CAPITAL_PRODUCT_MOTIVE) 'girl-sofa'
          else 'sign'
        }
      }

        return this.$cloudfrontURL(`/images/product-choice/${fileName}-97x97.jpg`);
    },
  },
};
</script>

<style lang="sass" scoped>
  @import '~@/sass/mixins'

  .product-choice-item
    position: relative

    display: flex
    align-items: center
    padding: 10px 12px
    margin-bottom: 8px

    border-radius: 6px
    border: solid 1px $primaryColor
    overflow: hidden
    cursor: pointer
    transition: box-shadow .2s linear

    &:hover
      box-shadow: 1px 2px 8px darken(white, 30%)

    &__icon
      position: relative
      width: 48px
      height: 48px

      img
        width: 100%
        height: 100%

      +tablet
        width: 64px
        height: 64px

    &__body
      flex: 1
      padding-left: 16px

    &__name
      font-size: 12px
      user-select: none

      +tablet
        font-size: 15px

    &__check
      $size: 18px
      $position: 10px

      position: absolute
      top: $position
      right: $position
      width: $size
      height: $size

      img
        width: 100%
        height: 100%

    &--selected
      background-color: transparentize($primaryColor, 0.92)
      .product-choice-item
        &__check
          border: none
</style>
